import React from 'react'
import { twMerge } from 'tailwind-merge'

export interface LoaderProps extends React.HTMLAttributes<HTMLSpanElement> {
  dataTestElement?: string
  className?: string
}

export const Loader = ({
  dataTestElement = '',
  className,
  ...props
}: LoaderProps) => (
  <span
    data-test-element={dataTestElement}
    className={twMerge(
      'float-left m-0 inline-block h-[14px] w-[14px] rounded-full border-2',
      'animate-spin border-primary-500 border-t-transparent',
      className,
    )}
    {...props}
  />
)
